module.exports = __webpack_public_path__ + "static/coaching_unten_cropped-df565f3a062dce4316ed759b5370a98f.jpg";